import {
  Component, ChangeDetectionStrategy,
} from '@angular/core';
import * as _ from 'lodash';

import { validationErrorStub } from 'shared/product/product-advanced-search/product-advanced-search.stub';

import { DashboardSearchPiesErrorsComponent } from './dashboard-search-pies-errors.component';


@Component({
  moduleId: module.id,
  selector: 'dashboard-search-pies67-errors',
  templateUrl: './base/dashboard-search.component.html',
  styleUrls: ['./base/dashboard-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardSearchPies67ErrorsComponent extends DashboardSearchPiesErrorsComponent {

  name: string = 'with-pies67-errors';
  text: string = 'PIES 6.7 validation errors';
  filterValue: any = _.find(validationErrorStub, {option: 'invalid-pies-67'});

}
